import type { ComponentProps, FC } from 'react';

type Props = ComponentProps<'span'>;

// Renders <span tabIndex={0}> so content is tabbable and focusable by screen readers.
// Use when keyboard focus is required; otherwise prefer semantic elements.
export const FocusableSpan: FC<Props> = ({ children, ...props }) => (
    <span
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={0}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
    >
        {children}
    </span>
);
